import React from 'react';

const Vue_Fallthrough = () => {
  return (
    <div>
      <h1>Vue_Fallthrough Component</h1>
      <p>This is the Vue_Fallthrough tutorial page.</p>
    </div>
  );
}

export default Vue_Fallthrough;
